import * as z from "zod";

export const getReturnItemResponseChips = {
  name: "getReturnItemResponseChips" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({
    items: z.array(
      z.object({ productId: z.string(), chips: z.array(z.string()) }),
    ),
  }),
};
